// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {
  // This is intentional
};

export const noopPromise = async <T>() => {
  return Promise.resolve({} as T);
};

export const noopObject = <T>() => {
  return {} as T;
};
